import { createFileRoute } from '@tanstack/react-router'
import { Payments } from '@/features/payments'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/payments/')({
  beforeLoad: requireAdmin,
  component: Payments,
})
